// extracted by mini-css-extract-plugin
export default {"ionButtons":"ReviewMaps_ionButtons__qkWtW","ionButtons__btn-icon":"ReviewMaps_ionButtons__btn-icon__x-A6P","ionButtons__btn-text":"ReviewMaps_ionButtons__btn-text__lrnC4"};